import styled from "styled-components";
import underConstructionImgSrc from "./assets/under-construction.png";

const Container = styled.div`
  background: url("./bg.jpg") no-repeat center center fixed;
  background-size: cover;
  background-color: #ffffff;
  transition: background 3s;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CenteredCard = styled.div`
  background-color: white;
  border-radius: 5px;
  min-width: 300px;
  min-height: 180px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  display:flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  &:hover {
    box-shadow: 0 19px 38px rgba(0, 0, 0, 0.3), 0 15px 12px rgba(0, 0, 0, 0.22);
  }
  img {
    width:20%;
  }
`;

function App() {
  return (
    <Container className="fade-in-bg">
      <CenteredCard>
        <img
          src={underConstructionImgSrc}
          alt={`<div>Icons made by <a href="https://www.flaticon.com/authors/soodesign" title="Soodesign">Soodesign</a> from <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a></div>`}
        />
        <p>Under construction</p>
      </CenteredCard>
    </Container>
  );
}

export default App;
